module.exports = "<div ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/firmwares/firmwares.html
// module id = 144
// module chunks = 0